import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { ProfileFormContext } from '../ProfileFormWrapper/ProfileFormWrapper.component';

import './ProfileActions.styles.scss';

type ProfileActionsProps = {
  className?: string;
  onSubmit?: () => void;
};

const ProfileActions: React.FC<ProfileActionsProps> = (props) => {
  const { children, className, onSubmit } = props;

  const { onCancel } = useContext(ProfileFormContext);

  const { pristine, submitting } = useFormState();

  const classes = classNames('profile-actions', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {children}

      {!pristine && (
        <Button variant="link" onClick={onCancel}>
          {t('cancel')}
        </Button>
      )}
      <Button
        type={onSubmit ? 'button' : 'submit'}
        disabled={onSubmit ? false : pristine || submitting}
        {...(onSubmit && { onClick: onSubmit })}
      >
        {t('saveChanges')}
      </Button>
    </div>
  );
};

export default ProfileActions;
